import { useMutation, useQuery } from '@tanstack/react-query'
import { KEY_FAVORITES } from './keys'
import { deleteFavorite, getFavorites, sendFavorite } from './resources'

export function useSendFavorite() {
  return useMutation({
    mutationFn: sendFavorite,
  })
}

export function useGetFavorites() {
  return useQuery({
    queryKey: [KEY_FAVORITES],
    queryFn: getFavorites,
  })
}

export function useDeleteFavorite() {
  const mutation = useMutation({
    mutationFn: deleteFavorite,
  })

  return mutation
}
